import type { IShopper } from "@apis/shoppers/types"
import { Button } from "@components/ui/button"
import { formatDate } from "@utils/formatters"
import { Link } from "react-router-dom"

type TProspectShopperProps = {
  prospectShopper: IShopper
}

export const ProspectShopper = ({ prospectShopper }: TProspectShopperProps) => {
  return (
    <Button
      variant="outline"
      className="tw:h-fit tw:items-start tw:gap-1"
      asChild
    >
      <Link
        to={`/prospect/${prospectShopper.prospect_guid}/new_order?shopper_guid=${prospectShopper.shopper_guid}`}
        className="tw:flex tw:flex-col"
      >
        <span className="tw:text-wrap">
          Market: {prospectShopper.market_code}
        </span>
        <span className="tw:text-wrap">
          Short key: {prospectShopper.short_key}
        </span>
        <span className="tw:text-wrap">
          Created: {formatDate(prospectShopper.created_at)}
        </span>
      </Link>
    </Button>
  )
}
